import type { ErrorEvent } from '@sentry/angular';

const PHONE_RE = /(\+?\d{2})\d{5,11}(\d{2})/g;

const maskPhones = (value: string): string => value.replace(PHONE_RE, '$1*****$2');

/** The console lists real users — their phones must not travel with an error report. */
export const scrubEvent = (event: ErrorEvent): ErrorEvent => {
  if (event.message) event.message = maskPhones(event.message);

  for (const exception of event.exception?.values ?? []) {
    if (exception.value) exception.value = maskPhones(exception.value);
  }

  if (event.request?.url) event.request.url = maskPhones(event.request.url);

  for (const breadcrumb of event.breadcrumbs ?? []) {
    if (breadcrumb.message) breadcrumb.message = maskPhones(breadcrumb.message);
    if (typeof breadcrumb.data?.['url'] === 'string') {
      breadcrumb.data['url'] = maskPhones(breadcrumb.data['url']);
    }
  }

  return event;
};
